export default __webpack_public_path__ + "static/media/Scholar's Gloves of the Effulgent Blade.cb14de2a.jpg";